import "@fontsource/roboto"
import "./src/styles/foundation/variable.css"
import "./src/styles/foundation/normalize.css"
import "./src/styles/foundation/base.css"
import "./src/styles/foundation/blog-contents-style.css"

import React, { useEffect } from "react"
import Lenis from "@studio-freight/lenis"

const WrapWithLenis = ({ element }) => {
    useEffect(() => {
        if (typeof window !== "undefined") {
            const lenis = new Lenis({
                duration: 1.2, // 慣性スクロールの強さ
                smooth: true,
            })

            function raf(time) {
                lenis.raf(time)
                requestAnimationFrame(raf)
            }
            requestAnimationFrame(raf)

            return () => {
                lenis.destroy()
            }
        }
    }, [])

    return <>{element}</>
}

export const wrapPageElement = ({ element }) => {
    return <WrapWithLenis element={element} />
}